module.exports = __webpack_public_path__ + "img/f.cce73bc5.jpg";